import React from "react";
import { ReactComponent as Frame11 } from "../components/assests/about/frame-11.svg";
import { ReactComponent as Frame37 } from "../components/assests/about/frame-37.svg";
import { ReactComponent as Frame48095965 } from "../components/assests/about/frame-48095965.svg";
import { ReactComponent as Frame48095967 } from "../components/assests/about/frame-48095967.svg";
import { ReactComponent as Frame48095972 } from "../components/assests/about/frame-48095972.svg";
import { ReactComponent as Frame48095976 } from "../components/assests/about/frame-48095976.svg";
import { ReactComponent as Frame48095977 } from "../components/assests/about/frame-48095977.svg";
import { ReactComponent as Frame48095978 } from "../components/assests/about/frame-48095978.svg";
import { ReactComponent as Frame48095998 } from "../components/assests/about/frame-48095998.svg";
import { ReactComponent as IconComponentNode } from "../components/assests/about/frame-11-1.svg";
import { ReactComponent as Intersect } from "../components/assests/about/intersect.svg";
import { ReactComponent as Line11 } from "../components/assests/about/line-11.svg";
import { ReactComponent as Line13 } from "../components/assests/about/line-13.svg";
import { ReactComponent as Line24 } from "../components/assests/about//line-24.svg";
import { ReactComponent as Line29 } from "../components/assests/about/line-29.svg";
import { ReactComponent as Line92 } from "../components/assests/about/line-92.svg";
import { ReactComponent as NamecandidateNameFrame11Score101 } from "../components/assests/about/frame-11-2.svg";
import { ReactComponent as Vector } from "../components/assests/about/vector.svg";
import "./style.css";
import cdascdscdcsaca1 from "../components/assests/about/cdascdscdcsaca-1.png";
import rectangle36 from "../components/assests/about/rectangle-3-6.png";
import aboutus256017061 from "../components/assests/about/about-us-2560x1706-1.png";
import group40897 from "../components/assests/about/group-40897.png";
import rectangle1024 from "../components/assests/about/rectangle-1024.png";
import group41225 from "../components/assests/about/group-41225.png";
import rectangle33 from "../components/assests/about/rectangle-3-3.png";
import rectangle32 from "../components/assests/about/rectangle-3-2.png";
import rectangle35 from "../components/assests/about/rectangle-3-5.png";
import rectangle34 from "../components/assests/about/rectangle-3-4.png";
import rectangle3 from "../components/assests/about/rectangle-3.png";
import group41210 from "../components/assests/about/group-41210.png";


export const About = () => {
  return (
    <div className="about">
      <div className="div">
        <div className="overlap">
          <div className="rectangle" />
          <img className="cdascdscdcsaca" alt="Cdascdscdcsaca" src={cdascdscdcsaca1} />
          <div className="frame">
            <div className="optimisez-le">
              Optimisez <br />
              le rendement
            </div>
            <p className="de-vos-placements">
              <span className="text-wrapper">
                <br />
                de vos <br />
              </span>
              <span className="span">placements</span>
            </p>
          </div>
          <div className="rectangle-2" />
          <div className="group">
            <div className="overlap-group">
              <div className="frame-2">
                <div className="overlap-group-wrapper">
                  <div className="overlap-group-2">
                    <p className="heading-example">
                      Beatimo est une entreprise renommée dans le domaine de l&#39;analyse et de l&#39;optimisation des
                      performances commerciales. Son expertise réside dans sa capacité à utiliser des données avancées
                      et des techniques d&#39;analyse pour aider les entreprises à améliorer leur efficacité
                      opérationnelle, leur rentabilité et leur croissance.
                    </p>
                    <div className="group-2" />
                  </div>
                </div>
                <p className="p">
                  Grâce à une équipe de professionnels hautement qualifiés et à des technologies de pointe, Beatimo
                  fournit des solutions personnalisées qui permettent aux entreprises de prendre des décisions éclairées
                  et de maximiser leur potentiel.
                </p>
                <div className="frame-wrapper">
                  <div className="frame-3">
                    <div className="div-wrapper">
                      <div className="frame-4">
                        <div className="text-wrapper-2">DÉCOUVRIR NOTRE ÉQUIPE</div>
                      </div>
                    </div>
                    <Frame11 className="frame-11" />
                  </div>
                </div>
              </div>
              <div className="frame-5">
                <div className="mission-vision-wrapper">
                  <p className="mission-vision">
                    <span className="text-wrapper-3">
                      Mission <br />
                    </span>
                    <span className="text-wrapper-4">&amp; Vision</span>
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div className="rectangle-3" />
          <div className="frame-6">
            <div className="group-3">
              <div className="frame-7">
                <Vector className="vector-instance" color="#FFFAE6" />
                <div className="heading-example-2">NOTRE EXPERTISE</div>
              </div>
            </div>
            <p className="une-expertise">
              <span className="text-wrapper-3">Une </span>
              <span className="text-wrapper-4">expertise </span>
              <span className="text-wrapper-3">approfondie en investissement </span>
              <span className="text-wrapper-4">immobilier</span>
              <span className="text-wrapper-3">
                .<br />
              </span>
            </p>
          </div>
          <div className="frame-8">
            <Line11 className="line" />
            <div className="frame-9">
              <div className="frame-10">
                <div className="text-wrapper-5">01</div>
                <div className="text-wrapper-6">Ingénierie financière</div>
              </div>
              <Frame48095972 className="icon-instance-node" />
            </div>
            <Line11 className="line-11" />
            <div className="frame-9">
              <div className="frame-10">
                <div className="text-wrapper-5">02</div>
                <div className="text-wrapper-7">Ingénierie financière</div>
              </div>
              <Frame48095972 className="icon-instance-node" />
            </div>
            <Line11 className="line-11" />
            <div className="frame-9">
              <div className="frame-10">
                <div className="text-wrapper-5">03</div>
                <div className="text-wrapper-7">Ingénierie financière</div>
              </div>
              <Frame48095972 className="icon-instance-node" />
            </div>
            <Line11 className="line-11" />
            <div className="frame-9">
              <div className="frame-10">
                <div className="text-wrapper-5">04</div>
                <div className="text-wrapper-7">Ingénierie financière</div>
              </div>
              <Frame48095972 className="icon-instance-node" />
            </div>
            <Line11 className="line-11" />
            <div className="frame-9">
              <div className="frame-10">
                <div className="text-wrapper-5">05</div>
                <div className="text-wrapper-7">Ingénierie financière</div>
              </div>
              <Frame48095972 className="icon-instance-node" />
            </div>
            <Line11 className="line-11" />
            <div className="frame-9">
              <div className="frame-10">
                <div className="text-wrapper-5">06</div>
                <div className="text-wrapper-7">Ingénierie financière</div>
              </div>
              <Frame48095972 className="icon-instance-node" />
            </div>
            <Line11 className="line-11" />
            <div className="frame-9">
              <div className="frame-10">
                <div className="text-wrapper-5">07</div>
                <div className="text-wrapper-7">Ingénierie financière</div>
              </div>
              <Frame48095972 className="icon-instance-node" />
            </div>
            <Line11 className="line-11" />
          </div>
          <img className="img" alt="Rectangle" src={rectangle36} />
          <img className="rectangle-4" alt="Rectangle" src={rectangle1024} />
          <div className="rectangle-5" />
          <img className="about-us" alt="About us" src={aboutus256017061} />
          <div className="group-4">
            <div className="frame-12">
              <div className="frame-13">
                <div className="frame-14">
                  <Line13 className="line-13" />
                  <div className="heading-example-3">Performante</div>
                </div>
                <Frame48095967 className="icon-instance-node" />
                <div className="group-5">
                  <p className="heading-example-4">
                    Nous valorisons la possibilité d&#39;investir, de contribuer à notre communauté et de nous
                    concentrer sur ce qui compte vraiment pour nous. Cela s&#39;atteint grâce à des stratégies orientés
                    vers la performance.
                  </p>
                  <Line13 className="line-13-instance" />
                </div>
              </div>
            </div>
          </div>
          <div className="group-6">
            <div className="frame-12">
              <div className="frame-13">
                <div className="frame-14">
                  <Line13 className="line-13" />
                  <div className="heading-example-3">Empathique</div>
                </div>
                <div className="intersect-wrapper">
                  <Intersect className="intersect-instance" />
                </div>
                <div className="group-5">
                  <p className="heading-example-4">
                    Nous partageons les mêmes rêves que nos clients. Nous comprenons leur réalité et appliquons les
                    mêmes outils et principes que nous proposons, assurant ainsi une expérience enrichissante.
                  </p>
                  <Line13 className="line-13-instance" />
                </div>
              </div>
            </div>
          </div>
          <div className="group-7">
            <div className="frame-12">
              <div className="frame-13">
                <div className="frame-14">
                  <Line13 className="line-13" />
                  <div className="heading-example-3">Experte</div>
                </div>
                <img className="group-8" alt="Group" src={group40897} />
                <div className="group-9">
                  <p className="heading-example-5">
                    Notre expertise se forge sur le terrain, allant au-delà des formations. Les projets complexes ont
                    affiné notre approche. Notre équipe, composée d&#39;actuaires et <br />
                    de passionnés, offre un accompagnement <br />
                    direct et transparent.
                  </p>
                  <Line13 className="line-2" />
                </div>
              </div>
            </div>
          </div>
          <div className="frame-15">
            <Frame48095965 className="icon-instance-node" />
            <div className="frame-16">
              <div className="navbar">
                <div className="text-wrapper-8">SERVICES</div>
                <div className="text-wrapper-8">À PROPOS</div>
                <div className="text-wrapper-8">CARRIÈRE</div>
                <div className="text-wrapper-8">RÉSEAUX SOCIAUX</div>
                <div className="text-wrapper-8">EN</div>
              </div>
              <img className="group-10" alt="Group" src={group41225} />
            </div>
          </div>
          <div className="rectangle-6" />
          <div className="group-11">
            <div className="frame-17">
              <div className="frame-18">
                <div className="group-12">
                  <div className="frame-7">
                    <Vector className="vector-instance" color="#EEFFF6" />
                    <div className="heading-example-6">NOTRE ÉQUIPE PASSIONNÉE</div>
                  </div>
                </div>
                <p className="cr-ateurs-de-valeur">
                  <span className="text-wrapper-3">
                    Créateurs
                    <br />
                    de valeur{" "}
                  </span>
                  <span className="text-wrapper-4">immobilière</span>
                </p>
              </div>
            </div>
            <div className="frame-19">
              <div className="frame-20">
                <img className="rectangle-7" alt="Rectangle" src={rectangle33} />
                <div className="group-13">
                  <Line92 className="line-92" />
                  <div className="frame-21">
                    <div className="frame-22">
                      <div className="frame-23">
                        <div className="text-wrapper-9">Philippe Foisy</div>
                      </div>
                      <div className="group-14">
                        <div className="frame-7">
                          <div className="heading-example-6">PRÉSIDENT ET FONDATEUR</div>
                        </div>
                      </div>
                    </div>
                    <Frame37 className="frame-37" />
                  </div>
                </div>
              </div>
              <div className="frame-20">
                <img className="rectangle-7" alt="Rectangle" src={rectangle32} />
                <div className="group-13">
                  <Line92 className="line-92" />
                  <div className="frame-21">
                    <div className="frame-22">
                      <div className="frame-23">
                        <div className="text-wrapper-9">Philippe Foisy</div>
                      </div>
                      <div className="group-14">
                        <div className="frame-7">
                          <div className="heading-example-6">PRÉSIDENT ET FONDATEUR</div>
                        </div>
                      </div>
                    </div>
                    <Frame37 className="frame-37" />
                  </div>
                </div>
              </div>
              <div className="frame-20">
                <img className="rectangle-7" alt="Rectangle" src={rectangle32} />
                <div className="group-13">
                  <Line92 className="line-92" />
                  <div className="frame-21">
                    <div className="frame-22">
                      <div className="frame-23">
                        <div className="text-wrapper-10">Philippe Foisy</div>
                      </div>
                      <div className="group-14">
                        <div className="frame-7">
                          <div className="heading-example-6">PRÉSIDENT ET FONDATEUR</div>
                        </div>
                      </div>
                    </div>
                    <Frame37 className="frame-37" />
                  </div>
                </div>
              </div>
              <div className="frame-20">
                <img className="rectangle-7" alt="Rectangle" src={rectangle35} />
                <div className="group-13">
                  <Line92 className="line-92" />
                  <div className="frame-21">
                    <div className="frame-22">
                      <div className="frame-23">
                        <div className="text-wrapper-9">Philippe Foisy</div>
                      </div>
                      <div className="group-14">
                        <div className="frame-7">
                          <div className="heading-example-6">PRÉSIDENT ET FONDATEUR</div>
                        </div>
                      </div>
                    </div>
                    <Frame37 className="frame-37" />
                  </div>
                </div>
              </div>
              <div className="frame-20">
                <img className="rectangle-7" alt="Rectangle" src={rectangle34} />
                <div className="group-13">
                  <Line92 className="line-92" />
                  <div className="frame-21">
                    <div className="frame-22">
                      <div className="frame-23">
                        <div className="text-wrapper-9">Philippe Foisy</div>
                      </div>
                      <div className="group-14">
                        <div className="frame-7">
                          <div className="heading-example-6">PRÉSIDENT ET FONDATEUR</div>
                        </div>
                      </div>
                    </div>
                    <Frame37 className="frame-37" />
                  </div>
                </div>
              </div>
              <div className="frame-20">
                <img className="rectangle-7" alt="Rectangle" src={rectangle32} />
                <div className="group-13">
                  <Line92 className="line-92" />
                  <div className="frame-21">
                    <div className="frame-22">
                      <div className="frame-23">
                        <div className="text-wrapper-9">Philippe Foisy</div>
                      </div>
                      <div className="group-14">
                        <div className="frame-7">
                          <div className="heading-example-6">PRÉSIDENT ET FONDATEUR</div>
                        </div>
                      </div>
                    </div>
                    <Frame37 className="frame-37" />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="group-wrapper">
            <div className="group-15">
              <Line24 className="line-24" />
              <div className="frame-24">
                <div className="frame-25">
                  <p className="text-wrapper-11">COPYRIGHT © 2024 BEATIMO | TOUT DROITS RÉSERVÉS</p>
                  <div className="text-wrapper-11">PRÉFÉRENCE DES TÉMOINS</div>
                  <div className="text-wrapper-11">POLITIQUES ET CONFIDENTIALITÉ</div>
                </div>
                <p className="site-par-les-mauvais">SITE PAR LES MAUVAIS GARÇONS</p>
              </div>
              <img className="group-16" alt="Group" src={group41210} />
              <div className="group-17">
                <Line29 className="line-29" />
                <Line29 className="line-25" />
                <Line29 className="line-26" />
                <div className="overlap-group-3">
                  <div className="text-wrapper-12">01</div>
                  <div className="text-wrapper-13">Facebook</div>
                </div>
                <div className="overlap-2">
                  <div className="text-wrapper-14">03</div>
                  <div className="text-wrapper-15">LinkedIn</div>
                </div>
                <Line29 className="line-30" />
                <div className="overlap-3">
                  <div className="text-wrapper-16">02</div>
                  <div className="text-wrapper-15">Youtube</div>
                </div>
                <div className="overlap-4">
                  <div className="text-wrapper-16">04</div>
                  <div className="text-wrapper-15">Tiktok</div>
                </div>
                <div className="group-18">
                  <div className="frame-7">
                    <Vector className="vector-instance" color="#FFFAE6" />
                    <div className="heading-example-2">NOS RÉSEAUX SOCIAUX</div>
                  </div>
                </div>
                <Frame48095976 className="frame-48095976" />
                <Frame48095977 className="frame-48095977" />
                <Frame48095978 className="frame-48095978" />
                <IconComponentNode className="frame-11-instance" />
              </div>
            </div>
          </div>
          <div className="rectangle-8" />
          <div className="frame-26">
            <div className="frame-27">
              <div className="frame-28">
                <Vector className="vector-instance" color="#EEFFF6" />
                <div className="heading-example-6">CARRIÈRE</div>
              </div>
              <p className="heading">
                <span className="text-wrapper-17">Nous </span>
                <span className="text-wrapper-18">sommes</span>
                <span className="text-wrapper-17"> toujours à  la recherche de </span>
                <span className="text-wrapper-18">talents</span>
                <span className="text-wrapper-17">.  Êtes-vous </span>
                <span className="text-wrapper-18">partant</span>
                <span className="text-wrapper-17"> ?</span>
              </p>
            </div>
            <div className="frame-wrapper">
              <div className="frame-3">
                <div className="frame-29">
                  <div className="frame-4">
                    <div className="text-wrapper-2">DÉCOUVRIR NOS POSTES</div>
                  </div>
                </div>
                <NamecandidateNameFrame11Score101 className="frame-11" />
              </div>
            </div>
          </div>
        </div>
        <div className="overlap-5">
          <Frame48095998 className="frame-48095998" />
          <Frame48095998 className="frame-48095998" />
          <Frame48095998 className="frame-48095998" />
          <Frame48095998 className="frame-48095998" />
          <Frame48095998 className="frame-48095998" />
          <Frame48095998 className="frame-48095998" />
        </div>
      </div>
    </div>
  );
};
export default About;